import styled from "@emotion/styled";

interface FilterButtonProps {
  hasFilterOptionsSelected: boolean;
  showingDropdown: boolean;
}

export const FilterButton = styled.button<FilterButtonProps>(props => ({
  borderRadius: "16px",
  background: props.hasFilterOptionsSelected
    ? "white"
    : props.theme.button.filter.unselected.surface.default,
  color: props.hasFilterOptionsSelected
    ? "black"
    : props.theme.button.filter.unselected.text.default,
  fontWeight: `${props.theme.fontWeights["work-sans-0"]}`,
  border: props.showingDropdown
    ? `1px solid ${props.theme.button.primary.surface.active}`
    : "1px solid transparent",
  padding: "6px 7px 6px 13px",
  marginRight: "4px",
  textAlign: "center",
  fontSize: `${props.theme.fontSize["4"]}`,
  lineHeight: `${props.theme.lineHeights[1]}`,
  height: "32px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",
  // Letter spacing of -0.03em specifically requested for filter button text
  letterSpacing: "-0.03em",
  whiteSpace: "nowrap",
  ":hover": {
    background: props.hasFilterOptionsSelected
      ? props.theme.button.secondary.surface.default
      : props.theme.surface.main.secondary.hover,
  },
}));
